<template>
<div class="rule-wrapper">
    <zm-button @click="deleteRule" type="icon" icon="zm-icon-delete">Delete</zm-button>
    <zm-form inline>
        <zm-form-item>
            <div slot="label">
                <tip label="level" id="alarmrule-rule-level"></tip>
            </div>
            <zm-select v-model="form.level">
                <zm-option label="FATAL" value="FATAL"></zm-option>
                <zm-option label="ERROR" value="ERROR"></zm-option>
                <zm-option label="WARN" value="WARN"></zm-option>
                <zm-option label="OK" value="OK"></zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item>
            <div slot="label">
                <tip label="lastCount" id="alarmrule-rule-lastCount"></tip>
            </div>
            <zm-input-number v-model="form.lastCount" style="width: 100px"></zm-input-number>
        </zm-form-item>
        <zm-form-item>
            <div slot="label">
                <tip label="lastTime" id="alarmrule-rule-lastTime"></tip>
            </div>
            <div style="width: 100%">
                <zm-input-number size="small" v-model="form.lastTime" :min="0" class="number-with-select" style="width: 100px"></zm-input-number>
                <zm-select size="small" v-model="form.timeUnit" class="select-with-number">
                    <zm-option value="SECONDS">SECONDS</zm-option>
                    <zm-option value="MINUTES">MINUTES</zm-option>
                    <zm-option value="HOURS">HOURS</zm-option>
                    <zm-option value="DAYS">DAYS</zm-option>
                </zm-select>
            </div>
        </zm-form-item>
    </zm-form>
    <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" v-if="!form.items.length">add parameter</zm-button>
    <zm-table :data="form.items">
        <zm-table-column label="name">
            <template slot-scope="scope">
                <!-- <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span> -->
                <zm-select v-model="scope.row.name" allow-create filterable>
                    <zm-option v-for="item in selectableKeys" :key="item.key"
                        :disabled="!item.active" :value="item.key" :label="item.key"></zm-option>
                </zm-select>
            </template>
        </zm-table-column>
        <zm-table-column label="operator">
            <template slot-scope="scope">
                <!-- <span v-if="!scope.row.isEdit">{{ scope.row.operator }}</span> -->
                <zm-select v-model="scope.row.operator">
                    <zm-option v-for="item in operatorList" :key="item"
                    :label="item" :value="item"></zm-option>
                </zm-select>
            </template>
        </zm-table-column>
        <zm-table-column label="value">
            <template slot-scope="scope">
                <!-- <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span> -->
                <zm-input v-model="scope.row.value"></zm-input>
            </template>
        </zm-table-column>
        <zm-table-column width="100px">
            <!-- eslint-disable-next-line -->
            <template slot="header" slot-scope="scope">
                <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add">add parameter</zm-button>
            </template>
            <template slot-scope="scope">
                <!-- <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                <zm-button size="small" type="icon" icon="zm-icon-ok" v-else @click="scope.row.isEdit = false"
                    :disabled="!scope.row.value.toString().length || !scope.row.name.length"></zm-button> -->
                <zm-button size="small" type="icon" icon="zm-icon-delete"
                    @click="deleteParam(scope.row)"></zm-button>
            </template>
        </zm-table-column>
    </zm-table>
</div>
</template>
<script>
import { listFields } from '@/api/monitorManager'
import tip from 'components/ToolTip/index'
export default {
    name: 'rule',
    props: ['index', 'metricName', 'data'],
    components: { tip },
    data () {
        return {
            form: {
                // id: '',
                items: [{
                    name: '',
                    operator: '',
                    value: '',
                    isEdit: true
                }],
                lastCount: 0,
                lastTime: 0,
                level: '',
                timeUnit: ''
            },
            fieldList: [],
            operatorList: ['>', '>=', '==', '!=', '<=', '<']
        }
    },
    created () {
        this.initData()
        this.fetchFields()
    },
    computed: {
        selectableKeys () {
            let data = this.fieldList
            this.fieldList.map(key => {
                key.active = true
                this.form.items.map(item => {
                    if (key.key === item.key) {
                        key.active = false
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.form.items.map(item => {
                if (!item.name || !item.value) {
                    data = true
                }
            })
            return data
        }
    },
    watch: {
        data () {
            this.initData()
        },
        metricName () {
            this.fetchFields()
        // },
        // id () {
        //     this.initData()
        // },
        // lastCount () {
        //     this.initData()
        // },
        // lastTime () {
        //     this.initData()
        // },
        // level () {
        //     this.initData()
        // },
        // timeUnit () {
        //     this.initData()
        }
    },
    methods: {
        fetchFields () {
            if (this.metricName) {
                listFields(this.metricName).then(response => {
                    this.fieldList = response.map(i => {
                        return {
                            key: i,
                            active: true
                        }
                    })
                })
            }
        },
        initData () {
            // this.form.id = this.data.id
            this.form.lastCount = this.data.lastCount
            this.form.lastTime = this.data.lastTime
            this.form.level = this.data.level
            this.form.timeUnit = this.data.timeUnit
            this.form.items = JSON.parse(JSON.stringify(this.data.items))
        },
        deleteRule () {
            this.$emit('deleteRule', this.index)
        },
        addParam () {
            this.form.items.unshift({
                name: '',
                operator: '==',
                value: '',
                isEdit: true
            })
        },
        deleteParam (row) {
            if (row.name) {
                this.form.items.map((item, index, arr) => {
                    if (item.name === row.name && item.operator === row.operator && item.value === row.value) {
                        this.form.items.splice(index, 1)
                    }
                })
            } else {
                this.form.items.shift()
            }
        }
    }
}
</script>
<style scoped>
.rule-wrapper {
    border: 1px solid #EAEAF0;
    box-sizing: border-box;
    padding: 5px 10px;
    border-radius: 12px;
}
</style>
